const Placeholder: FC = ({ children }) => (
  <div className="h-full w-full rounded-sm bg-gradient-to-r from-background to-secondary">
    {children}
  </div>
);

export default Placeholder;
